import React from "react";
import { useState, useEffect } from "react";
import { Col, Row, Card, Image, Spin, Empty, Carousel } from "antd";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import PropertyPlaceholder from "../../../assets/dashboard/propertyPlaceholder.png";

const Dashboard = () => {
  const [dashboard, setDashboard] = useState([]);
  const [loader, setLoader] = useState(true);
  const { Meta } = Card;

  // handler to get data for dashboard
  const getDashboardHandler = () => {
    setLoader(true);
    // login token
    const token = cookie.load("token");
    const config = {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` },
    };
    //axios call
    axios
      .get(`${process.env.REACT_APP_FRONTED_URL}/dashboard/count`, config)
      .then((response) => {
        console.log("response", response);
        setDashboard(response?.data);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  //  API for Faq
  useEffect(() => {
    getDashboardHandler();
  }, []);

  return (
    <React.Fragment>
      <div className="header">
        <h3>Dashboard</h3>
      </div>
      <div>
        <Row gutter={24} className="dashboard_card">
          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
            <div
              // onClick={() => navigate("/users-requests")}
              className="cursor-pointer"
            >
              <Card
                title="Total Properties"
                bordered={false}
                style={{
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  textAlign: "center",
                  margin: "15px 0px",
                }}
              >
                {loader ? (
                  <div className="spin_information_properties">
                    <Spin />
                  </div>
                ) : (
                  <p>{dashboard.totalProperties}</p>
                )}
              </Card>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
            <div
              // onClick={() => navigate("/users")}
              className="cursor-pointer"
            >
              <Card
                title="Off-Plan Properties"
                bordered={false}
                style={{
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  textAlign: "center",
                  margin: "15px 0px",
                }}
              >
                {loader ? (
                  <div className="spin_information_properties">
                    <Spin />
                  </div>
                ) : (
                  <p>{dashboard.totalOffplan}</p>
                )}
              </Card>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
            <div
              // onClick={() => navigate("/payments")}
              className="cursor-pointer"
            >
              <Card
                title="Sale Properties"
                bordered={false}
                style={{
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  textAlign: "center",
                  margin: "15px 0px",
                }}
              >
                {loader ? (
                  <div className="spin_information_properties">
                    <Spin />
                  </div>
                ) : (
                  <p>{dashboard.totalSale}</p>
                )}
              </Card>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
            <div className="cursor-pointer">
              <Card
                title="Rent Properties"
                bordered={false}
                style={{
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  textAlign: "center",
                  margin: "15px 0px",
                }}
              >
                {loader ? (
                  <div className="spin_information_properties">
                    <Spin />
                  </div>
                ) : (
                  <p>{dashboard.totalRent}</p>
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <div className="head_dashboard">
        <div className="header4">
          <h3>Latest Properties</h3>
          <div className="events-button">
            <Link to="/">
              <button className="cursor-pointer add-event">
                View All Properties
              </button>
            </Link>
          </div>
        </div>
        <div>
          {loader ? (
            <div>
              <Spin className="spin-center-normal" />
            </div>
          ) : dashboard?.propertiesWithSignedUrls?.length > 0 ? (
            <div>
              <Row gutter={24} scroll={{ x: 1023 }}>
                {dashboard?.propertiesWithSignedUrls?.map((item, id) => (
                  <Col xs={24} sm={24} md={12} lg={12} xl={6} key={id}>
                    <Card
                      hoverable
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                        margin: "15px 0px",
                      }}
                      cover={
                        item?.images?.length > 0 ? (
                          <Carousel>
                            {item?.images?.splice(0, 8)?.map((img, index) => (
                              <Image
                                height={330}
                                width={"100%"}
                                src={img?.url}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = PropertyPlaceholder;
                                }}
                                style={{ borderBottom: "1px solid #eee" }}
                                alt="example"
                                className="card-image"
                                key={index}
                              />
                            ))}
                          </Carousel>
                        ) : (
                          <Image
                            height={330}
                            width={"100%"}
                            src={PropertyPlaceholder}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = PropertyPlaceholder;
                            }}
                            style={{ borderBottom: "1px solid #eee" }}
                            alt="example"
                            className="card-image"
                          />
                        )
                      }
                    >
                      <Meta
                        title={<h4 className="card-name">{item?.title}</h4>}
                        description={
                          <div>
                            <p className="card-description">
                              <b>Reference Number: </b>
                              {item?.referenceNumber}
                            </p>
                            <p className="card-description">
                              <b>Status: </b>
                              {item?.status}
                            </p>
                            <p className="card-description">
                              <b>Type: </b>
                              {item?.type}
                            </p>
                          </div>
                        }
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <div className="empty-box-padding">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default Dashboard;
